'use strict'

import { user, sample, current, group } from '@/handler'
import ui from '@/libs/ui'
import util from '@/libs/util'
import file from '@/libs/file'
import { v4 as uuidv4 } from 'uuid'

let currentParam = {}

const commonInfo = (_this) => {
  const userInfo = _this.$store.state.userInfo
  const isAdmin = _this.$store.state.isAdmin
  const language = _this.$store.state.language
  const project = _this.$store.state.project
  const isSampleProject = project.type === 'sample'
  const setUserInfo = _this.$store._mutations.setUserInfo[0]
  const setProject = _this.$store._mutations.setProject[0]
  const setIsAdmin = _this.$store._mutations.setIsAdmin[0]
  const setSaveProjectPopupData =
    _this.$store._mutations.setSaveProjectPopupData[0]
  const setRenameProjectPopupData =
    _this.$store._mutations.setRenameProjectPopupData[0]
  const setUrlEditProjectPopupData =
    _this.$store._mutations.setUrlEditProjectPopupData[0]
  const setConfirmPopupData = _this.$store._mutations.setConfirmPopupData[0]
  return {
    userInfo,
    isAdmin,
    language,
    project: _.cloneDeep(project),
    isSampleProject,
    setUserInfo,
    setProject,
    setIsAdmin,
    setSaveProjectPopupData,
    setRenameProjectPopupData,
    setUrlEditProjectPopupData,
    setConfirmPopupData
  }
}

const commonInfoEx = (_this) => {
  let {
    isSampleProject,
    language,
    setRenameProjectPopupData,
    setUrlEditProjectPopupData,
    setConfirmPopupData
  } = commonInfo(_this)
  const t = _.get(currentParam, 'originProject.type')
  if (t) isSampleProject = t === 'sample'
  const originProject = currentParam.originProject
  const callback = currentParam.callback
    ? currentParam.callback
    : async () => {}
  let handler = user
  if (isSampleProject) {
    handler = sample
  }
  return {
    language,
    setRenameProjectPopupData,
    setUrlEditProjectPopupData,
    setConfirmPopupData,
    originProject,
    callback,
    handler
  }
}

const list = async (_this, tab) => {
  log('projectController.list()')
  if (tab) return await sample.list(tab)
  else return await user.list(_this)
}

const open = async (_this, project) => {
  log('projectController.open()')
  const { language } = commonInfo(_this)
  let messageType
  if (project.type === 'sample') {
    await sample.open(_this, project)
    messageType = _this.$t('Sample')
  } else {
    await user.open(_this, project)
    messageType = _this.$t('My')
  }
  ui.makeToast(
    _this,
    _this.$t('{projectName} {messageType} Project is opened!', {
      projectName: util.getProjectName(project, language),
      messageType
    }),
    'success'
  )
}

const save = async (_this) => {
  log('projectController.save()')
  const {
    isAdmin,
    project,
    language,
    isSampleProject,
    setSaveProjectPopupData
  } = commonInfo(_this)
  if (project.fileName) {
    if (isAdmin) {
      if (isSampleProject) saveSample(_this, project, language)
      else saveUser(_this, project, language)
    } else {
      if (isSampleProject) {
        setSaveProjectPopupData({
          isShow: true,
          saveHandler: saveHandler
        })
      } else {
        saveUser(_this, project, language)
      }
    }
  } else {
    setSaveProjectPopupData({
      isShow: true,
      saveHandler: saveHandler
    })
  }
}

const saveSample = async (_this, project, language) => {
  project.type = 'sample'
  await sample.save(_this, project)
  const messageType = _this.$t('Sample')
  await current.set(_this, project)
  ui.makeToast(
    _this,
    _this.$t('{projectName} {messageType} Project is saved!', {
      projectName: util.getProjectName(project, language),
      messageType
    }),
    'success'
  )
}

const saveUser = async (_this, project, language) => {
  project.type = 'user'
  await user.save(_this, project)
  const messageType = _this.$t('My')
  await current.set(_this, project)
  ui.makeToast(
    _this,
    _this.$t('{projectName} {messageType} Project is saved!', {
      projectName: util.getProjectName(project, language),
      messageType
    }),
    'success'
  )
}

const saveAs = async (_this, param) => {
  log('projectController.saveAs()')
  const { setSaveProjectPopupData } = commonInfo(_this)
  const originProject = _.cloneDeep(param.originProject)
  originProject.fileName = undefined
  setSaveProjectPopupData({
    isShow: true,
    originProject: originProject,
    saveHandler: saveHandler
  })
}

const saveCopy = async (_this, param = {}) => {
  log('projectController.saveCopy()')
  const { language } = commonInfo(_this)
  let { project, callback, tab } = param
  const saveproject = {
    fileName: uuidv4(),
    projectNames: {
      en: project.projectName
    },
    type: 'sample',
    tab: tab.id
  }
  await sample.save(_this, saveproject, project)
  await callback()
  ui.makeToast(
    _this,
    _this.$t('{projectName} Project is copied to Sample!', {
      projectName: util.getProjectName(project, language)
    }),
    'success'
  )
}

const saveHandler = async (_this, project, originProject = {}) => {
  log('projectController.saveHandler()')
  const { isAdmin, language, setSaveProjectPopupData } = commonInfo(_this)
  let handler = user
  let messageType = _this.$t('My')
  const saveproject = {
    fileName: project.fileName ? project.fileName : uuidv4()
  }
  if (project.type === 'sample' && isAdmin) {
    handler = sample
    messageType = _this.$t('Sample')
    saveproject.projectNames = project.projectNames
    saveproject.type = 'sample'
    saveproject.tab = project.tab
  } else {
    saveproject.type = 'user'
    if (project.projectName) saveproject.projectName = project.projectName
    else saveproject.projectName = util.getProjectName(project, language)
  }
  await handler.save(_this, saveproject, originProject)
  setSaveProjectPopupData({
    isShow: false
  })
  await current.set(_this, saveproject)
  ui.makeToast(
    _this,
    _this.$t('{projectName} {messageType} Project is saved!', {
      projectName: util.getProjectName(project, language),
      messageType
    }),
    'success'
  )
}

const rename = async (_this, param = {}) => {
  log('projectController.rename()')
  const { setRenameProjectPopupData } = commonInfo(_this)
  currentParam = param
  setRenameProjectPopupData({
    isShow: true,
    originProject: param.originProject,
    renameHandler: renameHandler
  })
}

const renameHandler = async (_this, renameProject) => {
  log('projectController.renameHandler()')
  const {
    language,
    setRenameProjectPopupData,
    originProject,
    callback,
    handler
  } = commonInfoEx(_this)
  await handler.save(_this, renameProject, originProject)
  setRenameProjectPopupData({
    isShow: false
  })
  await callback(renameProject, originProject)
  ui.makeToast(
    _this,
    _this.$t('{projectName} Project is renamed!', {
      projectName: util.getProjectName(renameProject, language)
    }),
    'success'
  )
}

const urlEdit = async (_this, param = {}) => {
  log('projectController.urlEdit()')
  const { setUrlEditProjectPopupData } = commonInfo(_this)
  currentParam = param
  setUrlEditProjectPopupData({
    isShow: true,
    originProject: param.originProject,
    urlEditHandler: urlEditHandler
  })
}

const urlEditHandler = async (_this, urlEditProject) => {
  log('projectController.urlEditHandler()')
  const {
    language,
    setUrlEditProjectPopupData,
    originProject,
    callback,
    handler
  } = commonInfoEx(_this)
  await handler.save(_this, urlEditProject, originProject)
  setUrlEditProjectPopupData({
    isShow: false
  })
  await callback(urlEditProject, originProject)
  ui.makeToast(
    _this,
    _this.$t('{projectName} Project url is changed!', {
      projectName: util.getProjectName(urlEditProject, language)
    }),
    'success'
  )
}

const remove = async (_this, param = {}) => {
  log('projectController.remove()')
  const { setConfirmPopupData } = commonInfo(_this)
  currentParam = param
  setConfirmPopupData({
    title: _this.$t('Delete Project'),
    message: _this.$t('Are you sure to delete the project?'),
    confirmHandler: removeHandler,
    isShow: true
  })
}

const removeHandler = async (_this) => {
  log('projectController.removeHandler()')
  const { language, setConfirmPopupData, originProject, callback, handler } =
    commonInfoEx(_this)
  if (originProject.fileName) {
    await handler.remove(_this, originProject)
  }
  setConfirmPopupData({
    isShow: false
  })
  await callback(originProject)
  ui.makeToast(
    _this,
    _this.$t('{projectName} Project is removed!', {
      projectName: util.getProjectName(originProject, language)
    }),
    'success'
  )
}

const removeAll = async (userInfo) => {
  await user.removeAll(userInfo)
  await group.remove(userInfo.uid)
}

const setCurrent = async (_this, project) => {
  log('projectController.setCurrent()')
  await current.set(_this, project)
}

const removeCurrent = async (_this) => {
  log('projectController.removeCurrent()')
  await current.remove(_this)
}

const setUserAndProject = async (_this, userInfo) => {
  log('projectController.setUserAndProject()')
  let { setUserInfo, setProject, setIsAdmin } = commonInfo(_this)
  const currentProject = await current.get(userInfo.uid)
  const g = await group.get(userInfo.uid)
  const project = util.getProject(currentProject)
  setUserInfo(userInfo)
  setIsAdmin(g && g.group === 'administrator')
  let xml
  if (project.fileName) {
    setProject(project)
    xml = await file.getSampleOrUser(project, userInfo.uid)
  }
  return Promise.resolve(xml)
}

const setGroup = async (uid, email) => {
  log('projectController.setGroup()')
  await group.set(uid, email)
}

export default {
  list,
  open,
  save,
  saveAs,
  saveCopy,
  rename,
  urlEdit,
  remove,
  removeAll,
  setCurrent,
  removeCurrent,
  setUserAndProject,
  setGroup
}
